<template>
    <b-modal
        v-model="modal"
        :title="modalContent.modalTitle"
        modal-class="apprentice-default-modal logbook-mutation"
        :ok-title="modalContent.edit ? $t('common.save') : $t('common.save')"
        ok-variant="primary"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        size="md"
        @ok="onOK">
        <b-alert
            v-for="(error, key) in modalContent.errors"
            show
            variant="danger"
            :key="key">
            {{ error }}
        </b-alert>

        <b-form class="logbook-mutation-form">
            <b-form-group
                label="Kies een leerling:*"
                label-for="student-selector">
                <template v-slot:label> Kies een leerling: <span class="required">*</span></template>
                <design-2021-apprentice-multiselect-component
                    id="student-selector"
                    v-model="modalContent.user"
                    :disabled="$authUser.isStudent()"
                    label="full_name"
                    :multiple-select="false"
                    :options="studentsIn"
                    track-by="id">
                </design-2021-apprentice-multiselect-component>
            </b-form-group>

            <div class="logbook-description">
                <b-form-group
                    :label="$t('common.description')"
                    label-for="logbook-description">
                    <template v-slot:label> {{ $t('common.description') }} <span class="required">*</span></template>
                    <b-form-textarea
                        class="apprentice-textarea"
                        id="logbook-description"
                        v-model="modalContent.description"
                        :placeholder="$t('log.fill_in_your_description')"
                        rows="3"
                        max-rows="6" />
                </b-form-group>
            </div>

            <div class="logbook-location">
                <b-form-group
                    :label="$t('common.location')"
                    label-for="logbook-location">
                    <template v-slot:label>
                        {{ $t('common.location') }}
                    </template>
                    <b-form-input
                        id="logbook-location"
                        v-model="modalContent.location"
                        type="text"
                        :placeholder="$t('common.location')"
                        locale />
                </b-form-group>
            </div>

            <div class="logbook-date">
                <b-form-group
                    label="Datum:*"
                    label-for="logbook-date">
                    <template v-slot:label> {{ $t('log.date') }}<span class="required">*</span></template>

                    <b-form-datepicker
                        class="apprentice-date-picker btn-date-group"
                        id="logbook-date"
                        v-model="modalContent.date"
                        start-weekday="1"
                        now-button
                        reset-button
                        right
                        today-variant="primary"
                        nav-button-variant="primary"
                        locale="nl"
                        :aria-controls="$t('log.choose_a_date')"
                        label-reset-button="Reset"
                        :label-no-date-selected="$t('log.no_date_selected')"
                        menu-class="datedropdown"
                        :date-format-options="{
                            year: 'numeric',
                            month: 'short',
                            day: '2-digit',
                            weekday: 'short',
                        }"></b-form-datepicker>
                </b-form-group>
            </div>

            <div class="logbook-time">
                <div class="start-time">
                    <b-form-group
                        class="start-time"
                        :label="$t('log.start_time')"
                        label-for="logbook-start-time">
                        <template v-slot:label> {{ $t('log.start_time') }} <span class="required">*</span></template>
                        <design-2021-apprentice-timepicker-component v-model="modalContent.start_time">
                        </design-2021-apprentice-timepicker-component>
                    </b-form-group>
                </div>

                <div class="end-time">
                    <b-form-group
                        class="end-time"
                        :label="$t('log.end_time')"
                        label-for="logbook-end-time">
                        <design-2021-apprentice-timepicker-component v-model="modalContent.end_time">
                        </design-2021-apprentice-timepicker-component>
                    </b-form-group>
                </div>
            </div>

            <div class="log-book-reflections">
                <b-form-group
                    :label="$t('log.reflection')"
                    label-for="logbook-reflections">
                    <template v-slot:label>
                        {{ $t('log.reflection') }}
                    </template>
                    <b-form-textarea
                        class="apprentice-textarea"
                        id="logbook-reflections"
                        v-model="modalContent.reflection"
                        :placeholder="$t('log.fill_in_your_reflection')"
                        rows="3"
                        max-rows="6" />
                </b-form-group>
            </div>
        </b-form>
    </b-modal>
</template>

<script>
import Design2021ApprenticeMultiselectComponent from '../../common/design-2021-apprentice-multiselect-component.vue';

export default {
    name: 'design-2021-log-data-mutation-modal-component',
    components: { Design2021ApprenticeMultiselectComponent },
    props: {
        studentsIn: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            modal: false,
            modalContent: {
                selectedStudent: this.$authUser.isStudent() ? this.$authUser : null,
            },
        };
    },
    methods: {
        onShow(content) {
            this.modal = true;
            this.modalContent = content;
        },

        onOK(bvModalEvt) {
            this.modalContent.errors = [];

            if (this.modalContent.description === '') {
                this.modalContent.errors.push(this.$t('log.description_is_a_mandatory_field'));
            }

            if (this.modalContent.date === '') {
                this.modalContent.errors.push(this.$t('log.date_is_a_mandatory_field'));
            }

            if (this.modalContent.start_time === '') {
                this.modalContent.errors.push(this.$t('log.start_time_is_a_mandatory_field'));
            }

            if (this.modalContent.end_time === '') {
                this.modalContent.errors.push(this.$t('log.end_time_is_a_mandatory_field'));
            } else if (this.modalContent.start_time === this.modalContent.end_time) {
                this.modalContent.errors.push(this.$t('log.end_time_cannot_be_equal_with_start_time'));
            }
            if (!this.modalContent.user) {
                this.modalContent.errors.push('Je hebt geen leerling geselecteerd.');
            }

            if (this.modalContent.errors.length) {
                bvModalEvt.preventDefault();
            } else {
                this.$emit('mutation-update', this.modalContent);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.logbook-time {
    display: block;
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .logbook-time {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .start-time {
            margin-right: $grid-gutter-width;
        }

        .start-time,
        .end-time {
            min-width: 180px;
            flex: 1;

            .apprentice-default-time-picker ::v-deep {
                input {
                    margin-bottom: 0;
                }
            }
        }
    }
}
</style>
